import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { UserEventTypeEnum } from "../enums/UserEventTypeEnum";
import { UserEventInstallation } from "./UserEventInstallation";

export class UserEvent {
    id: number;
    timestamp: Date;
    executorUsername: string;
    eventType: UserEventTypeEnum;
    executionTime: number;
    extraData: object;
    response: CReqExecutionResultEnum;
    responseData: object;
    involvedUser: string;
    involvedInstallations: Array<UserEventInstallation>;

    constructor() {}

    public parse(obj: any) {
        if (obj.Id != null && obj.Id != undefined) this.id = obj.Id;
        if (obj.Timestamp) this.timestamp = obj.Timestamp;
        if (obj.ExecutorUsername) this.executorUsername = obj.ExecutorUsername;
        if (obj.EventType != null && obj.EventType != undefined) this.eventType = obj.EventType;
        if (obj.ExecutionTime) this.executionTime = obj.ExecutionTime;
        if (obj.ExtraDataJSON) this.extraData = JSON.parse(obj.ExtraDataJSON);
        if (obj.Response != null) this.response = obj.Response;
        if (obj.ResponseDataJSON) this.responseData = JSON.parse(obj.ResponseDataJSON);
        if (obj.InvolvedUser) this.involvedUser = obj.InvolvedUser;
        if (obj.InvolvedInstallations) {
            this.involvedInstallations = new Array<UserEventInstallation>();
            obj.InvolvedInstallations.forEach((installation) => {
                let u = new UserEventInstallation();
                u.parse(installation);
                this.involvedInstallations.push(u);
            });
        }
    }
}
